/**
 * Stone Investment Property Amenities
 *
 * Stone-themed wrapper for the core PropertyAmenities component.
 * Applies Cormorant Garamond headings and greyscale palette.
 */

'use client';

import { PropertyAmenities, type PropertyAmenitiesProps } from '@/components/properties';

export type StonePropertyAmenitiesProps = PropertyAmenitiesProps;

export function StonePropertyAmenities(props: PropertyAmenitiesProps) {
  return (
    <div
      className="
        relative
        font-['Montserrat',-apple-system,BlinkMacSystemFont,'Segoe_UI',sans-serif]
        [&_h2]:font-['Cormorant_Garamond','Georgia',serif]
        [&_h3]:font-['Cormorant_Garamond','Georgia',serif]
        **:rounded-none
      "
    >
      <PropertyAmenities {...props} className="" />
    </div>
  );
}
